/* Fulfilment Station - meetlaag voor sales en marketing.

   1. Houdt vast waar een bezoeker vandaan komt (utm-parameters en de klik-id's
      van Google, Meta, LinkedIn, Microsoft en TikTok).
   2. Stuurt die herkomst mee met een offerteaanvraag, zodat verkoop in HubSpot
      ziet uit welke campagne een lead komt.
   3. Laat beide formulieren eindigen op /pages/bedankt, zodat er een echte
      conversie-URL bestaat waar advertentieplatformen op kunnen meten.
   4. Meldt de conversie daar precies een keer.

   Opslaan gebeurt pas na toestemming. Zonder toestemming blijft de herkomst in
   het geheugen van deze ene paginaweergave en verdwijnt hij daarna. */
(function () {
  var KEY = 'fs-herkomst';
  var BEDANKT = '/pages/bedankt';
  var VLAG = 'fs-conversie';
  var VELDEN = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
                'gclid', 'gbraid', 'wbraid', 'fbclid', 'li_fat_id', 'msclkid', 'ttclid'];
  var KLIK = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'li_fat_id', 'msclkid', 'ttclid'];

  function magOpslaan() {
    try { return localStorage.getItem('fs-cookie-consent') === 'granted'; } catch (e) { return false; }
  }
  function datum() { return new Date().toISOString().slice(0, 10); }
  function kort(s) { return String(s).replace(/[\r\n\t]/g, ' ').slice(0, 120); }

  /* --- 1. herkomst bepalen --------------------------------------------- */
  function uitHuidigeUrl() {
    var p, o = null;
    try { p = new URLSearchParams(location.search); } catch (e) { return null; }
    VELDEN.forEach(function (v) {
      var w = p.get(v);
      if (w) { o = o || {}; o[v] = kort(w); }
    });
    if (!o) return null;
    o.pagina = location.pathname;
    o.datum = datum();
    if (document.referrer && document.referrer.indexOf(location.host) < 0) {
      o.verwijzer = kort(document.referrer.split('?')[0]);
    }
    return o;
  }
  function uitVerwijzer() {
    if (!document.referrer || document.referrer.indexOf(location.host) > -1) return null;
    return { verwijzer: kort(document.referrer.split('?')[0]), pagina: location.pathname, datum: datum() };
  }

  var geheugen = null;
  function lees() {
    if (magOpslaan()) {
      try { var r = localStorage.getItem(KEY); if (r) return JSON.parse(r); } catch (e) {}
    }
    return geheugen;
  }
  function schrijf(o) {
    geheugen = o;
    if (magOpslaan()) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  }
  function bijwerken() {
    var nieuw = uitHuidigeUrl() || uitVerwijzer();
    if (!nieuw) return;
    var b = lees() || {};
    if (!b.eerste) b.eerste = nieuw;
    b.laatste = nieuw;
    schrijf(b);
  }
  bijwerken();

  /* Gaat de bezoeker later alsnog akkoord, dan mag wat in het geheugen zit
     alsnog bewaard worden. De cookiebanner staat vooraan in de pagina, dus een
     klik daarop komt hier langs. */
  document.addEventListener('click', function () {
    if (geheugen && magOpslaan()) { try { localStorage.setItem(KEY, JSON.stringify(geheugen)); } catch (e) {} }
  }, true);

  function regel(x, label) {
    if (!x) return '';
    var s = [];
    if (x.utm_source) s.push('bron ' + x.utm_source);
    if (x.utm_medium) s.push('kanaal ' + x.utm_medium);
    if (x.utm_campaign) s.push('campagne ' + x.utm_campaign);
    if (x.utm_term) s.push('zoekterm ' + x.utm_term);
    if (x.utm_content) s.push('variant ' + x.utm_content);
    KLIK.forEach(function (k) { if (x[k]) s.push(k + ' ' + x[k]); });
    if (!s.length && x.verwijzer) s.push('via ' + x.verwijzer);
    if (!s.length) return '';
    return label + ': ' + s.join(', ') + ' | binnengekomen op ' + x.pagina + ' op ' + x.datum;
  }
  function samenvatting() {
    var b = lees();
    if (!b) return '';
    /* Kwam iemand maar een keer binnen, dan is een regel genoeg. Pas als het
       eerste en het laatste bezoek verschillen wordt het twee regels. */
    var zelfde = JSON.stringify(b.eerste || null) === JSON.stringify(b.laatste || null);
    if (zelfde) return regel(b.laatste || b.eerste, 'Herkomst');
    var e = regel(b.eerste, 'Eerste bezoek'), l = regel(b.laatste, 'Laatste bezoek');
    if (e && l) return e + '\n' + l;
    return e || l;
  }
  window.fsHerkomst = function () { return { ruw: lees(), tekst: samenvatting() }; };

  /* --- 2. herkomst meesturen met de inzending --------------------------- */
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (u, o) {
      var uu = u, oo = o;
      try {
        var url = (typeof u === 'string') ? u : (u && u.url) || '';
        if (url.indexOf('hsforms.com/submissions') > -1 && o && typeof o.body === 'string') {
          var tekst = samenvatting();
          if (tekst) {
            var d = JSON.parse(o.body);
            if (d && d.fields && d.fields.length) {
              var m = null, i;
              for (i = 0; i < d.fields.length; i++) { if (d.fields[i].name === 'message') { m = d.fields[i]; break; } }
              if (m) { m.value = (m.value ? m.value + '\n\n' : '') + tekst; }
              else { d.fields.push({ name: 'message', value: tekst }); }
              oo = {};
              for (i in o) { if (Object.prototype.hasOwnProperty.call(o, i)) oo[i] = o[i]; }
              oo.body = JSON.stringify(d);
            }
          }
        }
      } catch (e) { uu = u; oo = o; }
      return origFetch.call(this, uu, oo);
    };
  }

  /* --- 3. na een inzending naar de bedanktpagina ------------------------ */
  function naarBedankt(bron) {
    try { sessionStorage.setItem(VLAG, bron); } catch (e) {}
    location.href = BEDANKT;
  }

  /* Het eigen formulier vervangt bij succes zijn inhoud door een blok dat
     begint met een kop "Bedankt". Een foutmelding doet dat niet. */
  var eigen = document.querySelector('[data-quote-form]');
  if (eigen && window.MutationObserver) {
    var mo = new MutationObserver(function () {
      var k = eigen.querySelector('h3');
      if (k && /^Bedankt/i.test(k.textContent.trim())) { mo.disconnect(); naarBedankt('offerteformulier'); }
    });
    mo.observe(eigen, { childList: true, subtree: true });
  }

  /* De HubSpot-insluiting staat op een ander domein en meldt zich via een
     bericht aan het venster. */
  window.addEventListener('message', function (ev) {
    try {
      var d = ev.data;
      if (d && d.type === 'hsFormCallback' && d.eventName === 'onFormSubmitted') naarBedankt('hubspot-formulier');
    } catch (e) {}
  });

  /* --- 4. de conversie melden ------------------------------------------ */
  if (location.pathname.indexOf(BEDANKT) === 0) {
    var bron = null;
    try { bron = sessionStorage.getItem(VLAG); sessionStorage.removeItem(VLAG); } catch (e) {}
    /* Zonder vlag is dit geen verse inzending maar iemand die de pagina
       rechtstreeks opent. Dan tellen we niets, anders lopen de cijfers op. */
    if (bron) {
      var b = lees() || {}, h = b.laatste || b.eerste || {};
      var gegevens = {
        formulier: bron,
        bron: h.utm_source || (h.verwijzer ? 'verwijzing' : 'direct'),
        kanaal: h.utm_medium || '',
        campagne: h.utm_campaign || ''
      };
      window.dataLayer = window.dataLayer || [];
      var d2 = { event: 'lead_aanvraag' };
      for (var k in gegevens) { if (Object.prototype.hasOwnProperty.call(gegevens, k)) d2[k] = gegevens[k]; }
      window.dataLayer.push(d2);

      /* Het eigen formulier meldt generate_lead al zelf op de pagina waar het
         staat. Alleen de HubSpot-insluiting deed dat nog niet, dus die melden
         we hier. Zo blijft het een gebeurtenis per aanvraag. */
      if (bron === 'hubspot-formulier') {
        try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', gegevens); } catch (e) {}
      }

      /* Ruimte voor de conversietags van de advertentieplatformen. Vul het
         nummer in en haal het commentaarteken weg zodra het account er is.

         Google Ads:  window.gtag && gtag('event','conversion',{send_to:'AW-000000000/xxxxxxxxxxx'});
         Meta:        window.fbq && fbq('track','Lead');
         LinkedIn:    window.lintrk && lintrk('track',{conversion_id:0000000});
         Microsoft:   window.uetq && uetq.push('event','lead',{}); */
    }
  }
})();
